import {IRecipe} from '@/models/iRecipe';

export default class AppStorage {
    recipes: IRecipe[] = [];
    contentfulSpace: string = 'yxiai8wna167';
    contentfulAccessToken: string = 'MOVJ69-0g8_-xbFXUHUzTjHvSoikWuoyRJJ1hsMVnL8';
}
